import React, {useCallback} from 'react';

import {Group} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';
import SlideBox from '@pb/kit-component-slide-box';

import {slideBox, slideBoxButton, slideBoxCaption, slideBoxIcon} from './slide-box.module.styl';

import type {ReactNode} from 'react';

type Props = {
    isExpanded: boolean,
    caption: string,
    onToggle: (isExpanded: boolean) => void,
    children: ReactNode,
};

export const SlideBoxComponent: React.FC<Props> = ({isExpanded, children, caption, onToggle}) => {
    const onButtonClick = useCallback(() => {
        onToggle(!isExpanded);
    }, [isExpanded, onToggle]);

    return (
        <div className={slideBox}>
            <div onClick={onButtonClick} className={slideBoxButton}>
                <Group justify="space-between" alignItems="center">
                    <Group className={slideBoxCaption}>
                        <Icon
                            className={slideBoxIcon}
                            type={isExpanded ? Icons.ANGLE_UP : Icons.ANGLE_DOWN}
                        />
                        {caption}
                    </Group>
                </Group>
            </div>
            <SlideBox shown={isExpanded}>
                {children}
            </SlideBox>
        </div>
    );
};
